module.exports = __webpack_public_path__ + "img/b_4.f8c6281a.jpg";